import { render, staticRenderFns } from "./ourmissionandvision.vue?vue&type=template&id=ff2e7f72&"
import script from "./ourmissionandvision.vue?vue&type=script&lang=js&"
export * from "./ourmissionandvision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports